var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewHampshire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "288px",
    height: "288px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.486,207.991l-9.602-6.003v-11.581l-13.031-5.311l-2.416-9.167L124.172,26.306l-3.376,9.651l-6.755-6.272l-9.171,29.442 v22.202l9.171,14.959v11.587l-16.896,14.478c0,0-7.722,2.896-7.722,5.31c0,2.411,4.346,11.583,4.346,11.583L88.458,225.1 l4.827,7.301l-1.275,28.38l77.856-16.313c0,0,18.662-20.598,21.881-19.311c0.459,0.183,1.139,0.693,1.949,1.389l5.771-17.314 L197.486,207.991z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewHampshire);
export default __webpack_public_path__ + "static/media/newHampshire.8fee780bacde362e1e21540fc3fde49a.svg";
export { ForwardRef as ReactComponent };